import { axiosInstance } from './common';

export const getDataCapturesList = () => axiosInstance.get(`/datacapture/list`).then((response) => response.data);

export const getDataCapture = (dataCaptureId) =>
  axiosInstance.get(`/datacapture/${dataCaptureId}`).then((response) => response.data);

export const getStreamingLink = (dataCaptureId) =>
  axiosInstance.get(`/datacapture/streaming/${dataCaptureId}`).then((response) => response.data);

export const deleteMultipleDataCaptures = (dataCaptureIds) =>
  axiosInstance.delete(`/datacapture/deleteMultiple`, { data: dataCaptureIds }).then((response) => response.data);

export const searchDataCaptures = (searchParams) =>
  axiosInstance.get(`/datacapture/search`, { params: searchParams }).then((response) => response.data);

export const updateDataCapture = (dataCapture) =>
  axiosInstance.post(`/datacapture/update`, dataCapture).then((response) => response.data);